import { useMerchant } from "@/hooks/useMerchant";
import { toaster } from "@/components/ui/toaster";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useProtectTRPC } from "../trpc";
import { triggerDownload } from "../triggerDownload";

export function useDownloadApprovalLetter() {
  const trpc = useProtectTRPC();
  const { merchant } = useMerchant();
  const queryClient = useQueryClient();
  const [downloading, setDownloading] = useState(false);

  const downloadApprovalLetter = async (screeningId: string) => {
    if (!merchant?.id || downloading) return;
    setDownloading(true);

    try {
      const url = await queryClient.fetchQuery(
        trpc.screenings.getApprovalLetterUrl.queryOptions({
          rentalsMerchantId: merchant.id,
          id: screeningId,
        })
      );
      triggerDownload(url);
    } catch {
      toaster.create({
        title: "Error",
        description: "No fue posible descargar la carta de aprobación.",
        type: "error",
        duration: 5000,
        meta: { closable: true },
      });
    } finally {
      setDownloading(false);
    }
  };

  return { downloadApprovalLetter, downloading };
}
